import {
  Dropdown,
  LeadsTasksListData,
  PaginatedDropdownList,
  PaginatedTaskTypeListReadable,
  TaskTypeReadable,
  TaskTypesListData,
  taskTypesListInfiniteOptions,
  UsersListListData,
  usersListListInfiniteOptions
} from '@crm/api'
import { InfiniteSelect, RangePickerFilter } from '@crm/components'
import { useRolePermission } from '@crm/hooks/useRolePermission'
import { UserRoleCRM } from '@crm/types'
import {
  defaultFiltersMultipleValues,
  defaultFiltersNumberValues,
  listTransformResults,
  TagPriorityByValue
} from '@crm/utils'

import { MoreFiltersPopover } from '@shared/components'
import { useQueryUpdate } from '@shared/hooks'
import { defaultFilters } from '@shared/utils'
import { Select } from 'antd'
import { useTranslation } from 'react-i18next'

export const TasksFilter = () => {
  const { params, updateQuery } = useQueryUpdate()
  const { t } = useTranslation()

  const hasPermissionMix = useRolePermission([
    UserRoleCRM.manager,
    UserRoleCRM.admin
  ])

  const userValue = defaultFiltersMultipleValues(params?.owner)
  const typeValue = defaultFiltersNumberValues(params?.type)

  const filtersCount = ['deadline_start', 'type', 'priority'].filter(
    (filter) => params?.[filter]
  )?.length

  const onFilterChange = (
    filter: keyof NonNullable<LeadsTasksListData['query']>,
    value: string[] | string | number
  ) => updateQuery({ [filter]: value, page: defaultFilters.page })

  const onResetMoreFilters = () =>
    updateQuery({
      deadline_start: undefined,
      deadline_end: undefined,
      type: undefined,
      priority: undefined
    })

  return (
    <>
      {hasPermissionMix && (
        <InfiniteSelect<UsersListListData, PaginatedDropdownList, Dropdown>
          value={userValue}
          className="select-min-width"
          popupMatchSelectWidth
          placeholder={t('filter.lead_owner')}
          getQueryFunction={usersListListInfiniteOptions}
          onChange={(owner) => updateQuery({ owner })}
          baseOptions={{
            query: {
              preference: params?.owner
            }
          }}
        />
      )}

      <MoreFiltersPopover
        filterActiveCount={filtersCount}
        onResetMoreFilters={onResetMoreFilters}
      >
        <RangePickerFilter
          fromParam="deadline_start"
          toParam="deadline_end"
          placeholder={[t('deadline_start'), t('deadline_end')]}
        />

        <InfiniteSelect<
          TaskTypesListData,
          PaginatedTaskTypeListReadable,
          TaskTypeReadable
        >
          value={typeValue}
          className="w-full"
          popupMatchSelectWidth
          placeholder={t('task.task_type')}
          getQueryFunction={taskTypesListInfiniteOptions}
          onChange={(type) => onFilterChange('type', type)}
          baseOptions={{
            query: {
              preference: typeValue ? [typeValue] : undefined
            }
          }}
          getOptions={({ options }) => listTransformResults(options)}
        />

        <Select
          allowClear
          value={params?.priority ? Number(params?.priority) : undefined}
          onChange={(priority) => onFilterChange('priority', priority)}
          placeholder={t('task.priority')}
          options={Object.entries(TagPriorityByValue(t)).map(
            ([key, value]) => ({
              label: value.title,
              value: Number(key)
            })
          )}
        />
      </MoreFiltersPopover>
    </>
  )
}
